import PropTypes from 'prop-types';
import React from 'react';
import MetaDataWrapper from 'modules/Common/containers/MetaDataWrapper';
import {titleTemplate} from 'utils/seoUtils';

const helmetProps = {
  titleTemplate: titleTemplate.horseRacing
}

export default function HorseRacingBase({children}) {
  return (
    <div className="horse-racing-content">
      <MetaDataWrapper helmetProps={helmetProps}/>
      {children}
    </div>
  );
}

HorseRacingBase.propTypes = {
  children: PropTypes.any
}



// WEBPACK FOOTER //
// ./modules/HorseRacing/components/HorseRacingBase.js